/// <reference types="./connector_settings.d.mts" />
import * as $crypto from "../../gleam_crypto/gleam/crypto.mjs";
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $regexp from "../../gleam_regexp/gleam/regexp.mjs";
import * as $bit_array from "../../gleam_stdlib/gleam/bit_array.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $connector from "../data/connector.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, toList, Empty as $Empty, CustomType as $CustomType, makeError } from "../gleam.mjs";

const FILEPATH = "src/data/connector_settings.gleam";

export class GoogleDrive extends $CustomType {
  constructor(pages) {
    super();
    this.pages = pages;
  }
}

export class Confluence extends $CustomType {
  constructor(pages) {
    super();
    this.pages = pages;
  }
}

export class Website extends $CustomType {
  constructor(pages) {
    super();
    this.pages = pages;
  }
}

export function encode_data(connector_settings) {
  return $json.object(
    toList([["pages", $json.array(connector_settings.pages, $json.string)]]),
  );
}

export function encode(connector_settings) {
  let kind_data_encoder = (connector_kind) => {
    return $json.object(
      toList([
        ["kind", $connector.encode(connector_kind)],
        ["data", encode_data(connector_settings)],
      ]),
    );
  };
  if (connector_settings instanceof GoogleDrive) {
    return kind_data_encoder(new $connector.GoogleDrive());
  } else if (connector_settings instanceof Confluence) {
    return kind_data_encoder(new $connector.Confluence());
  } else {
    return kind_data_encoder(new $connector.Website());
  }
}

export function decoder() {
  return $decode.then$(
    $decode.at(toList(["kind"]), $connector.decoder()),
    (type_) => {
      if (type_ instanceof $connector.GoogleDrive) {
        let pages$1 = $decode.at(
          toList(["pages"]),
          $decode.list($decode.string),
        );
        return $decode.field(
          "data",
          $decrypt.json(pages$1),
          (data) => { return $decode.success(new GoogleDrive(data)); },
        );
      } else if (type_ instanceof $connector.Confluence) {
        let pages$1 = $decode.at(
          toList(["pages"]),
          $decode.list($decode.string),
        );
        return $decode.field(
          "data",
          $decrypt.json(pages$1),
          (data) => { return $decode.success(new Confluence(data)); },
        );
      } else if (type_ instanceof $connector.Website) {
        let pages$1 = $decode.at(
          toList(["pages"]),
          $decode.list($decode.string),
        );
        return $decode.field(
          "data",
          $decrypt.json(pages$1),
          (data) => { return $decode.success(new Website(data)); },
        );
      } else {
        let type_$1 = $connector.to_string(type_);
        let expected = ("ConnectorSettings(" + type_$1) + ")";
        return $decode.failure(new GoogleDrive(toList([])), expected);
      }
    },
  );
}

export function is_google_drive(settings) {
  if (settings instanceof GoogleDrive) {
    return true;
  } else {
    return false;
  }
}

export function is_confluence(settings) {
  if (settings instanceof Confluence) {
    return true;
  } else {
    return false;
  }
}

export function is_website(settings) {
  if (settings instanceof Website) {
    return true;
  } else {
    return false;
  }
}

export function pages(settings) {
  if (settings instanceof GoogleDrive) {
    let pages$1 = settings.pages;
    return new Ok(pages$1);
  } else if (settings instanceof Confluence) {
    let pages$1 = settings.pages;
    return new Ok(pages$1);
  } else {
    let pages$1 = settings.pages;
    return new Ok(pages$1);
  }
}

export function kind(settings) {
  if (settings instanceof GoogleDrive) {
    return new $connector.GoogleDrive();
  } else if (settings instanceof Confluence) {
    return new $connector.Confluence();
  } else {
    return new $connector.Website();
  }
}

export function normalize_page_url(url, connector) {
  if (connector instanceof $connector.Website) {
    let $ = $regexp.from_string("/+$");
    if (!($ instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "data/connector_settings",
        104,
        "normalize_page_url",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $,
          start: 2629,
          end: 2674,
          pattern_start: 2640,
          pattern_end: 2646
        }
      )
    }
    let re = $[0];
    return $regexp.replace(re, url, "");
  } else {
    return url;
  }
}

export function normalized_page_url_to_document_id(url, connector) {
  if (connector instanceof $connector.Confluence) {
    let $ = $regexp.from_string("(?<=\\/pages\\/)\\d+(?=\\/)");
    if (!($ instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "data/connector_settings",
        123,
        "normalized_page_url_to_document_id",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $,
          start: 3062,
          end: 3130,
          pattern_start: 3073,
          pattern_end: 3078
        }
      )
    }
    let r = $[0];
    let matches = $regexp.scan(r, url);
    let _block;
    if (matches instanceof $Empty) {
      _block = url;
    } else {
      let $1 = matches.tail;
      if ($1 instanceof $Empty) {
        let match = matches.head;
        _block = match.content;
      } else {
        _block = url;
      }
    }
    let res = _block;
    return res;
  } else if (connector instanceof $connector.Website) {
    let _pipe = $crypto.hash(new $crypto.Sha1(), $bit_array.from_string(url));
    let _pipe$1 = $bit_array.base16_encode(_pipe);
    return $string.lowercase(_pipe$1);
  } else {
    return url;
  }
}

export function set_website_pages(settings, pages) {
  let $ = is_website(settings);
  if ($) {
    return new Website(pages);
  } else {
    return settings;
  }
}

export function set_confluence_pages(settings, pages) {
  let $ = is_confluence(settings);
  if ($) {
    return new Confluence(pages);
  } else {
    return settings;
  }
}

export function set_google_folder_urls(settings, pages) {
  let $ = is_google_drive(settings);
  if ($) {
    return new GoogleDrive(pages);
  } else {
    return settings;
  }
}
